import React from 'react'
import strings from '../../../lang/strings'

export default function TableCellGameRate(props) {
  return (
    <div className={'d-center ' + props.className}>
      <div className={'d-flex flh-1'}>
        <div className={'d-center ' + (props.selected === 0 ? 'rate-choose-active' : 'rate-choose-normal')} onClick={() => {props.onChange(0)}}>
          <div className={'text-center fs-14 f-r'}>
            <div className={props.selected !== 0 ? 'color-3a3335' : 'color-ffffff'}>{props.type == 2 ? strings.u : props.type == 4 ? strings.odd : strings.win}</div>
            {props.selected !== 0 && <div className={'mt-5'}>{props.home_rate}</div>}
            {props.selected === 0 && <div className={'mt-5 color-ffffff'}>{props.home_rate}</div>}
          </div>
          {props.ans == 0 && <img className='rate-sel-check' src={'/assets/image/chk4.png'} alt={''} />}
        </div>
        {props.no_rate > 0 &&
        <div className={'d-center mh-6 ' + (props.selected === 1 ? 'rate-choose-active' : 'rate-choose-normal')} onClick={() => {props.onChange(1)}}>
          <div className={'text-center fs-14 f-r'}>
            <div className={props.selected !== 1 ? 'color-3a3335' : 'color-ffffff'}>{props.type == 3 ? strings.one : strings.draw}</div>
            {props.selected !== 1 && <div className={'mt-5'}>{props.no_rate}</div>}
            {props.selected === 1 && <div className={'mt-5 color-ffffff'}>{props.no_rate}</div>}
          </div>
          {props.ans == 1 && <img className='rate-sel-check' src={'/assets/image/chk4.png'} alt={''} />}
        </div>
        }
        {props.no_rate == 0 && <div className={'wx-49 mh-6 d-center fs-14'}>{'-'}</div>}
        <div className={'d-center ' + (props.selected === 2 ? 'rate-choose-active' : 'rate-choose-normal')} onClick={() => {props.onChange(2)}}>
          <div className={'text-center fs-14 f-r'}>
            <div className={props.selected !== 2 ? 'color-3a3335' : 'color-ffffff'}>{props.type == 2 ? strings.o : props.type == 4 ? strings.even : strings.lose}</div>
            {props.selected !== 2 && <div className={'mt-5'}>{props.away_rate}</div>}
            {props.selected === 2 && <div className={'mt-5 color-ffffff'}>{props.away_rate}</div>}
          </div>
          {props.ans ==2 && <img className='rate-sel-check' src={'/assets/image/chk4.png'} alt={''} />}
        </div>
      </div>
    </div>
  )
}

